import script from "./DSPageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DSPageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DSPageHeader.vue?vue&type=style&index=0&id=0a2d9a51&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2d9a51"]])

export default __exports__